import React, { useState, useContext } from 'react';
import cn from 'classnames';
import useSWR from 'swr';
import { AppContext } from 'Context';
import { dataFetcher, endpoints } from 'Api';
import { Collapse, Zoom } from '@mui/material';
import styles from './index.module.css';

const transitionTimeout = 300;

// Lucide trash icon (MIT) for the Remove action.
const IconTrash = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    className={styles.actionIcon}
  >
    <path d="M3 6h18" />
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    <line x1="10" x2="10" y1="11" y2="17" />
    <line x1="14" x2="14" y1="11" y2="17" />
  </svg>
);

const UserRequest = ({ email, id, firstname, lastname, setSnackbar, setSuccessor, successors }) => {
  const [isVisible, setVisibility] = useState(true);
  const [selectedSuccessor, selectSuccessor] = useState(undefined);
  const { langText } = useContext(AppContext);
  const commonText = langText?.common;
  const { isValidating: deletingUser, mutate: deleteUser } = useSWR([endpoints.removeSuccessor, id], {
    fetcher: (url, userId) => dataFetcher(url, { user_id: userId }),
    onSuccess: ({ success }) => {
      if (success) {
        setSnackbar({
          isVisible: true,
          message: `${firstname ? `${firstname}` : 'User'} removed`
        });
      } else {
        setSnackbar({ isVisible: true, message: 'Oops! Something went wrong', type: 'error' });
      }
      setVisibility(false);
    },
    onError: () => {
      setSnackbar({ isVisible: true, message: 'Oops! Something went wrong', type: 'error' });
    },
  });

  return (
    <Collapse in={isVisible} timeout={transitionTimeout}>
      <Zoom in={isVisible} timeout={transitionTimeout}>
        <div className={styles.userRequest}>
          <div className={styles.userMemberStyle}>
            <div className={styles.profileIcon}>
              {`${firstname ? firstname.charAt(0).toUpperCase() : email.charAt(0).toUpperCase()}`}
            </div>
            <div className={styles.userRequestText}>
              <div className={styles.userRequestName}>{`${firstname} ${lastname}`}</div>
            </div>
          </div>
          <div className={styles.userRequestEmail}>{email}</div>
          <div className={styles.userRequestActionsContainer}>
            <button
              className={cn({ [styles.userRequestActionButton]: true, [styles.delete]: true, [styles.deleteActive]: true })}
              onClick={() => { deleteUser(); }}
            >
              <IconTrash />
              {deletingUser ? `${(commonText?.removing || 'Removing')}...` : (commonText?.remove || 'Remove')}
            </button>
          </div>
        </div>
      </Zoom>
    </Collapse>
  );
};
export default UserRequest;
